<template>
  <div class="content" ref="content">
    <!-- <iframe id="dialogFrame" :src="srcV" frameborder="0" scrolling="no" style=" position: fixed; z-index: 1000; width: 50%; height: 50%; top: 0;left:0;"></iframe> -->
    <div class="contorlContent">
      <div class="itemContorl" @click="setCanvasF(5)">
        <div class="type type_5"></div>
        <span class="text">车辆切换</span>
        <div class="line"></div>
      </div>
      <div class="itemContorl" @click="setCanvasF(1)">
        <div class="type type_1"></div>
        <span class="text">原始比例</span>
        <div class="line"></div>
      </div>
      <div class="itemContorl" @click="setCanvasF(2)">
        <div class="type type_2"></div>
        <span class="text">放大</span>
        <div class="line"></div>
      </div>
      <div class="itemContorl" @click="setCanvasF(3)">
        <div class="type type_3"></div>
        <span class="text">缩小</span>
        <div class="line"></div>
      </div>
      <div class="itemContorl" @click="setCanvasF(4)">
        <div class="type type_4"></div>
        <span class="text">{{ leftOutText }}</span>
      </div>
    </div>
    <div class="setCarInfo" ref="setCarInfo" v-show="carSetShow">
      <div class="setCarTitle">{{ fabricClickName }}</div>
      <div class="setCarBtnL">启动</div>
      <div class="setCarBtnR">紧停</div>
    </div>
    <canvas id="myCanvas" :width="canvasW" :height="canvasH"></canvas>
    <canvas id="midCanvas" :width="canvasW" :height="canvasH"></canvas>
    <canvas id="dhCanvas" :width="canvasW" :height="canvasH"></canvas>
    <!-- <img id="pavImg" src="../../images/car/pav.png" alt=""> -->
    <div class="warnNumContent" ref="warnNumContent" @click="warnShow">
      <div class="warnNum">{{ warnNum }}</div>
      <div class="warnText">报警</div>
    </div>
    <div class="warnContent" ref="warnContent">
      <div class="warnItemTop" v-for="item in topWarnList" :key="item.index">
        <div class="itemTop" v-for="i in item.list" :key="i.index">
          <div class="itemType">{{ i.cnName }}</div>
          <div class="itemEquipName">{{ item.equipName }}</div>
          <div class="setStop">紧停</div>
        </div>
        <div
          style="width: 100%; height: 1px; background: #e1e1e1; margin-top: 5px"
        ></div>
      </div>
      <div class="warnItem" v-for="item in warnList" :key="item.index">
        <div class="itemTitle">
          <span class="bgLine"></span>
          <span class="itemTitleText">{{ item.equipName }}</span>
        </div>
        <div class="itemContent">
          <div class="itemShow" v-for="i in item.list" :key="i.index">
            <span class="redPointer"></span>{{ i.cnName }}
          </div>
          <div style="clear: both"></div>
        </div>
      </div>
    </div>
    <div class="setMonitor" :class="leftOut == true ? 'leftOut' : ''">
      <div class="title_1">
        <div class="iconShow"></div>
        <div class="titleText">工程视图</div>
      </div>
      <div class="setMonitorItem">
        <div class="itemText">选择工程</div>
        <div class="projectCon">
          <!-- <el-input placeholder="请输入标段名称" ></el-input> -->
          <el-select
            v-model="search.project"
            @change="projectChange"
            placeholder="请选择工程"
          >
            <el-option
              v-for="item in projectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="workCon">
          <!-- <el-input placeholder="请输入标段名称" ></el-input> -->
          <el-select
            v-model="search.work"
            @change="workChange"
            placeholder="请选择作业"
          >
            <el-option
              v-for="item in workList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div style="clear:both"></div>
      </div>
      <div class="setMonitorItem" v-show="changShow">
        <div class="itemText">监控维度</div>
        <div class="projectCon" style="display: none">
          <!-- <el-input placeholder="请输入标段名称" ></el-input> -->
          <el-select
            @change="parameterChange"
            v-model="parameterArr"
            multiple
            collapse-tags
            placeholder="请选择监控参数"
          >
            <el-option
              v-for="item in parameterList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="projectCon">
          <!-- <el-input placeholder="请输入标段名称" ></el-input> -->
          <el-select
            @change="dimensionChange"
            v-model="search.dimension"
            placeholder="请选择维度"
          >
            <el-option
              v-for="item in dimensionList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div style="clear:both"></div>
      </div>
      <div class="setMonitorItem" v-if="!REShow">
        <div class="itemText">时间范围</div>
        <div class="projectConD">
          <el-date-picker
            v-model="value2"
            type="datetimerange"
            @change="getSTime"
            format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          >
          </el-date-picker>
        </div>
        <div style="clear:both"></div>
      </div>
      <div class="timeCheckItem" v-if="!REShow">
        <div class="timeCheck">时间范围选择:</div>
        <div
          class="timeCheck"
          v-for="(item, index) in timeList"
          :key="index"
          @click="setTime(item)"
        >
          起始 {{ item.startTime }} 结束 {{ item.endTime }}
        </div>
      </div>

      <div class="setMonitorItem" v-if="!REShow">
        <el-button
          style="float: right; margin-right: 16px"
          type="primary"
          @click="startRE"
          plain
          >确认</el-button
        >
      </div>
      <!-- <div class="setMonitorItem"  v-if="!REShow" style="padding-left:14px;padding-right:14px"> -->
      <!-- <c-progress class="c-progress" :percent="percentNum" @percentChange="onPercentChange" @upChange="upSetChange" :width="350" :showPerText="false" />
            <div class="nowDateTimeShow">{{nowDateTimeShow}}</div> -->
      <!-- </div> -->
    </div>

    <div class="progressContent" v-if="!REShow">

        <!-- <span class="playState" @click="setPlayState">{{playStateText}}</span> -->
        <div class="playAndPuase_1" @click="setPlayState" v-if="playStateText == '播放'"></div>
        <div class="playAndPuase_2" @click="setPlayState" v-if="playStateText == '暂停'"></div>
        <span class="speedText">播放速度</span>
        <el-select @change="playCodeChange" v-model="playCodeName" placeholder="" class="playCodeChange">
            <el-option
            v-for="item in playSpeedList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
        <c-progress class="c-progress" :percent="percentNum" @percentChange="onPercentChange" @upChange="upSetChange" :width="1872" :showPerText="false" />
        <div class="nowDateTimeShow">{{nowDateTimeShow}}</div>

    </div>

    <div
      class="infoListContent"
      v-if="REShow"
      :class="leftOut == true ? 'leftOut' : ''"
    >
      <div class="infoTab">
        <div
          class="tabItem"
          @click="tabChange('0')"
          v-bind:class="tabChangeCode == 0 ? 'tabItem_w' : ''"
        >
          作业
        </div>
        <div
          class="tabItem"
          @click="tabChange('1')"
          v-bind:class="tabChangeCode == 1 ? 'tabItem_r' : ''"
        >
          工程
        </div>
        <div
          class="tabItem"
          @click="tabChange('2')"
          v-bind:class="tabChangeCode == 2 ? 'tabItem_l' : ''"
        >
          设备
        </div>
      </div>
      <transition name="el-fade-in">
        <div class="infoListShow workProgress" v-show="tabChangeCode == 0">
          <div class="workProgress_title">
            <img class="iconImg" src="../../images/all/icon_3.png" alt="" />
            作业进度
          </div>
          <div
            class="workProgress_content"
            v-for="(item, index) in progressList"
            :key="index"
          >
            <el-row>
              <el-col :span="14"
                ><div :style="{ fontWeight: index == 0 ? 'bold' : 'normal' }">
                  {{ item.name }}进度：
                </div></el-col
              >
              <el-col :span="10">
                <div>
                  <el-progress
                    :percentage="item.percentage"
                    :stroke-width="8"
                  ></el-progress>
                  <!-- -- -->
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14"
                ><div :style="{ fontWeight: index == 0 ? 'bold' : 'normal' }">
                  已作业时长/剩余时长：
                </div></el-col
              >
              <el-col :span="10">
                <div>
                  {{item.workTime}} / {{item.remainTime}}
                  <!-- --/-- -->
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </transition>
      <transition name="el-fade-in">
        <div class="infoListShow" v-show="tabChangeCode == 1">
          <div
            class="infoItemSetMask"
            :class="{ leftToShowClass: showCode, leftToHideClass: hideCode }"
          >
            <div class="maskBack" @click="maskBack">←</div>
            <div class="setMaskTitle">{{ maskBackTitle }}</div>
            <div class="workSet">
              <WorkSet :maskBackCode="maskBackCode"></WorkSet>
            </div>
          </div>
          <el-table
            :data="workList"
            style="width: 100%;cursor:pointer"
            size="medium"
            v-loading="listLoading"
            @cell-mouse-enter="roadChange"
            @cell-mouse-leave="roadChangeClose"
            @row-click="lookWork"
          >
            <el-table-column
              prop="name"
              label="作业"
              width=""
              
            ></el-table-column>
            <el-table-column prop="status" label="状态" width="">
              <template slot-scope="scope">
                <span class="wordStatus_1" v-if="scope.row.status == 0"
                  >未完成</span
                >
                <span class="wordStatus_2" v-if="scope.row.status == 1"
                  >作业中</span
                >
                <span class="wordStatus_3" v-if="scope.row.status == 2"
                  >完成</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="typeName" label="进度" width="">
              <template slot-scope="scope">
                <el-progress
                   v-if="scope.row.id != 10000"
                  :percentage="(scope.row.process * 100).toFixed(2)"
                  :stroke-width="8"
                ></el-progress>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="" label="操作" width="">
                    <template slot-scope="scope">
                        <span class="contorClick" @click="contorFun(scope.row.id,scope.row.name)">展开</span>
                    </template>
                </el-table-column> -->
          </el-table>
        </div>
      </transition>
      <transition name="el-fade-in">
        <div class="infoListShow" v-show="tabChangeCode == 2">
          <el-table
            :data="equipmnetList"
            style="width: 100%"
            size="medium"
            v-loading="listLoading"
          >
            <el-table-column
              prop="name"
              label="名称"
              width=""
            ></el-table-column>
            <el-table-column prop="status" label="状态" width="">
              <template slot-scope="scope">
                <span class="wordStatus_1" v-if="scope.row.workStatus == 0"
                  >离线</span
                >
                <span class="wordStatus_2" v-if="scope.row.workStatus == 1"
                  >空闲</span
                >
                <span class="wordStatus_3" v-if="scope.row.workStatus == 2"
                  >作业中</span
                >
                <span class="wordStatus_4" v-if="scope.row.workStatus == 3"
                  >紧停</span
                >
                <span class="wordStatus_4" v-if="scope.row.workStatus == 4"
                  >暂停</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="jobType" label="工序" width="">
              <template slot-scope="scope">
                  <span>{{jobType[scope.row.jobType + ""]}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </transition>
    </div>

    <div
      class="colorContent"
      ref="colorContent"
      v-if="search.dimension != 1 && search.dimension"
    >
      <div class="colorType">
        <div
          class="colorItem colorItem_1"
          :class="search.dimension == 2 ? 'colorActive' : ''"
        >
          遍数
        </div>
        <div
          class="colorItem colorItem_2"
          :class="search.dimension == 3 ? 'colorActive' : ''"
        >
          压实
        </div>
        <div
          class="colorItem colorItem_3"
          :class="search.dimension == 4 ? 'colorActive' : ''"
        >
          摊铺温度
        </div>
        <div
          class="colorItem colorItem_4"
          :class="search.dimension == 5 ? 'colorActive' : ''"
        >
          碾压温度
        </div>
      </div>
            <RollLegend class="rollLegend" v-show="search.dimension == 2" fontColor="black" legendType="1"></RollLegend>
            <RollLegend class="rollLegend" v-show="search.dimension == 3" fontColor="wblack" legendType="2"></RollLegend>
            <RollLegend class="rollLegend" v-show="search.dimension == 4" fontColor="wblack" legendType="3"></RollLegend>
            <RollLegend class="rollLegend" v-show="search.dimension == 5" fontColor="wblack" legendType="4"></RollLegend>
      <!-- <div class="rollImg" v-show="search.dimension == 2"></div> -->
      <!-- <div class="icvImg" v-show="search.dimension == 3"></div> -->
    </div>
  </div>
</template>

<script>
import { fabric } from "fabric";
import canvasMix from "../../utils/canvasMix";
import RollLegend from "../quality/part/rollLegend";
import { setGrid } from "../../utils/canvasSet";
import {
  getEnginList,
  getWorks,
  getWorkEquipsList,
  getWorkInfo,
  getRoadSectionPointer,
  getWorkTimeList,
  getProjectRoadData,
  getProjectEquipsList,
  getProjectSetting
} from "../../utils/api";
import {
  changeRoadPointer,
  changeUnRoadPointer,
  dateFormat,
} from "../../utils/commons";
import { createSocket, sendWSPush, closeWs } from "../../utils/websocket";
import mixinList from "../../utils/mixinList";
import WorkSet from "../../components/engineering/workSet";
import CProgress from "../../components/c-progress";
import websockMix from "../../utils/websockMix";
import Cookies from "js-cookie";
export default {
  name: "app",
  mixins: [mixinList, canvasMix, websockMix],
  data() {
    return {
      changShow: true,
      carSetShow: false,
      arrowList: [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "质量管理",
          path: "/transfer/quality",
        },
        {
          name: "",
          path: "/transfer/quality",
        },
        {
          name: "作业回放",
          path: "",
        },
      ],
      projectList: [],
      equipmnetList: [],
      parameterList: [
        {
          label: "压实度",
          value: "icv",
        },
        {
          label: "速度",
          value: "speed",
        },
        {
          label: "温度",
          value: "temperature",
        },
        {
          label: "剩余油量",
          value: "oilmass",
        },
        {
          label: "振动频率",
          value: "frequencyVal",
        },
        {
          label: "振动振幅",
          value: "swingVal",
        },
      ],
      jobType: {
        0: "未绑定",
        1: "初压",
        2: "复压",
        3: "终压",
        4: "摊铺",
        5: "压实",
      },
      dimensionList: [
        {
          label: "轨迹",
          value: "1",
        },
        {
          label: "遍数",
          value: "2",
        },
        {
          label: "压实度",
          value: "3",
        },
        {
          label: "摊铺温度",
          value: "4",
        },
        {
          label: "碾压温度",
          value: "5",
        },
      ],
      workList: [],
      aShow: false,
      search: {
        project: "",
        work: "",
        dimension: "",
      },
      tabChangeCode: 0,
      canvas: "",
      midCanvas: "",
      fabricClickId: "", //canvas 点击到的车辆id
      fabricClickName: "",
      parameterArr: [
        "icv",
        "speed",
        "temperature",
        "oilmass",
        "frequencyVal",
        "swingVal",
      ],
      parameterPavArr: ["speed", "temperature", "oilmass"],
      parameterRollDArr: [
        "icv",
        "speed",
        "temperature",
        "oilmass",
        "frequencyVal",
        "swingVal",
      ],
      parameterRollSArr: [
        "icv",
        "speed",
        "temperature",
        "oilmass",
        "frequencyVal",
        "swingVal",
      ],
      parameterRollLArr: ["speed", "temperature", "oilmass"],
      setMask: 0,
      showCode: false,
      hideCode: false,
      maskBackTitle: "",
      maskBackCode: 0,
      dimension: 1,
      warnShowCode: 0,
      carWidthMap: "",
      scaleCode: "",
      REShow: true,
      value2: "",
      type: "",
      startTime: "",
      endTime: "",
      workId: "",
      oldWorkId: '',
      allTime: "", // 时间范围时间戳
      nowDateTimeShow: "", // 回放当前时间
      percentNum: 0,
      workType: 4,
      progress: [
        {
          name: "总体",
          percentage: 0,
          workTime: "--",
          remainTime: "--",
        },
      ],
      progressList: [],
      timeList: [],
      perCode: 0,
      playCode: 1,
      playCodeName: "X1",
      playStateText: "暂停",
      playSpeedList: [
        {
          label: "X1",
          value: "1",
        },
        {
          label: "X2",
          value: "2",
        },
        {
          label: "X4",
          value: "3",
        },
      ],
      leftOut: false,
      leftOutText: "清屏",
      roadType:1,
      canvasW: 0,
      canvasH: 0,
      interFun: '',
      roadAllList: [],
      roadOutList: [],
      workEquipList: {},
      carPointObj: {},
      carChangeCode: 0
    };
  },
  computed: {},
  created() {
    // closeWs()
    // let that = this
    // setInterval(function(){
    //     that.percentNum = that.percentNum + 1
    //     console.log(that.percentNum)
    // },1000)
  },
  mounted() {
    
    this.canvasW = this.$refs.content.offsetWidth
    this.canvasH = this.$refs.content.offsetHeight
    console.log('start')
    this.$store.commit("setArrowList", this.arrowList);
    this.$emit("changeArrowShow", false); // 隐藏arrow
    localStorage.setItem('carPointObj',JSON.stringify(this.carPointObj))
    let type = this.$route.query.type;
    this.type = this.$route.query.type;
    if (type == "RE") {
      // 回放
      this.workId = this.$route.query.workId;
      this.oldWorkId = this.$route.query.workId
      this.arrowList[2].name = this.$route.query.workName;
      this.$emit("changeArrowShow", true); // 隐藏arrow
      this.REShow = false;
      this.getSetInfo();
      this.getTimeCheckList(this.workId);
      this.carList = [];
      createSocket("wss://" + localStorage.getItem("webSocketUrl") + "/ws");
    } else {
      this.REShow = true;
      this.getSetInfo();
      console.log("wss://" +localStorage.getItem("webSocketUrl"))
      createSocket("wss://" + localStorage.getItem("webSocketUrl") + "/ws");
    }
    setTimeout(function(){
      setGrid();
    },100)
    this.interFun = setInterval(()=>{
        getWorks({projectId:this.search.project}).then((res) => {
          this.workList = res.data.content.info.list;
          if (this.workList.length == 0) {
            this.$message({
              message: "已选工程下暂无作业！请在工程管理新增作业。",
              type: "warning",
            });
            this.search.work = "";
            clearInterval(this.interFun)
          }else{
            this.workList.map(item=>{
              item.id=item.id*1
            })
            if(this.workList[0].workType == 2 || this.workList[0].workType == 1){
              this.workList.unshift({
                id: 10000,
                name: '全部'
              })
            }
          }
          
        })
        if(this.search.work == 10000){
          getProjectEquipsList({projectId:this.search.project}).then(res=>{
            this.equipmnetList = res.data.content.dataList;
            this.progress = [];
            this.progress.push({
              name: "总体",
              percentage: 0,
              workTime: "00:00:00",
              remainTime: "00:00:00",
            });
            this.equipmnetList.map((item) => {
              this.progress.push({
                name: item.name,
                percentage: 0,
                workTime: "00:00:00",
                remainTime: "00:00:00",
                code: item.code,
              });
            });
          })
        }else{
          if(this.search.work){
            getWorkEquipsList({workId:this.search.work}).then((res) => {
              this.equipmnetList = res.data.content.dataList;
              let list = res.data.content.dataList;
              this.progress = [];
              this.progress.push({
                name: "总体",
                percentage: 0,
                workTime: "00:00:00",
                remainTime: "00:00:00",
              });
              this.equipmnetList.map((item) => {
                this.progress.push({
                  name: item.name,
                  percentage: 0,
                  workTime: "00:00:00",
                  remainTime: "00:00:00",
                  code: item.code,
                });
              });
              for(let i=0;i<list.length;i++){
                this.workEquipList[list[i].code] = list[i].name
              }
            })
          }
          
        }
        
    },10000)
  },
  methods: {
    getProjectSettingF(params){
      getProjectSetting(params).then((res) => {
        let that =this
        let info = res.data.content.info;
        let compactionColorList = info.compactionColorList;
        let rollingColorList = info.rollingColorList;
        let paverTemperatureColorList = info.paverTemperatureColorList
        let temperatureColorList = info.temperatureColorList

        let rollNumColorArr = new Array();
        let rollNumColor = {};
        let icvColor = {};
        let icvColorArr = new Array();
        let pavColor = {};
        let pavColorArr = new Array();
        let rollColor = {};
        let rollColorArr = new Array();

        if (
          rollingColorList != null &&
          rollingColorList != undefined &&
          rollingColorList.length > 0
        ) {
          for (let i = 0; i < rollingColorList.length; i++) {
            let colorData = rollingColorList[i];
            rollNumColorArr.push(colorData.color);
            rollNumColor[colorData.num] = colorData.color;
          }
          that.$store.commit("setRollNumColor", rollNumColor);
          that.$store.commit("setRollNumColorArr", rollNumColorArr);
        } else {
          // that.$store.commit("setRollNumColor", that.rollNumColor);
          // that.$store.commit("setRollNumColorArr", that.rollNumColorArr);
        }

        if (
          compactionColorList != null &&
          compactionColorList != undefined &&
          compactionColorList.length > 0
        ) {
          for (let j = 0; j < compactionColorList.length; j++) {
            let compactionColor = compactionColorList[j];
            icvColorArr.push(compactionColor.color);
            icvColor[compactionColor.maxCompaction] = compactionColor.color;
          }

          that.$store.commit("setIcvColor", icvColor);
          that.$store.commit("setIcvColorArr", icvColorArr);
        } else {
          // that.$store.commit("setIcvColor", that.icvColor);
          // that.$store.commit("setIcvColorArr", that.icvColorArr);
        }

        if (
          paverTemperatureColorList != null &&
          paverTemperatureColorList != undefined &&
          paverTemperatureColorList.length > 0
        ) {
          for (let j = 0; j < paverTemperatureColorList.length; j++) {
            let compactionColor = paverTemperatureColorList[j];
            pavColorArr.push(compactionColor.color);
            pavColor[compactionColor.maxTemperature] = compactionColor.color;
          }

          that.$store.commit("setPavColor", pavColor);
          that.$store.commit("setPavColorArr", pavColorArr);
        } else {
          // that.$store.commit("setIcvColor", that.icvColor);
          // that.$store.commit("setIcvColorArr", that.icvColorArr);
        }

        if (
          temperatureColorList != null &&
          temperatureColorList != undefined &&
          temperatureColorList.length > 0
        ) {
          for (let j = 0; j < temperatureColorList.length; j++) {
            let compactionColor = temperatureColorList[j];
            rollColorArr.push(compactionColor.color);
            rollColor[compactionColor.maxTemperature] = compactionColor.color;
          }

          that.$store.commit("setRollColor", rollColor);
          that.$store.commit("setRollColorArr", rollColorArr);
          console.log(Object.keys(rollColor))
        } else {
          // that.$store.commit("setIcvColor", that.icvColor);
          // that.$store.commit("setIcvColorArr", that.icvColorArr);
        }
      });
    },
    
    lookWork(e){
      this.search.work = e.id*1
      this.workChange(e.id)
    },
    roadChangeClose(){
      let canvasArr = this.canvas.getObjects()
      for(let i=0;i<canvasArr.length;i++){
        if(canvasArr[i].id == 'roadChange'){
          this.canvas.remove(canvasArr[i])
        }
      }
    },
    roadChange(e){
      console.log(e)
      let list = this.roadAllList
      let setList = []
      for(let i=0;i<list.length;i++){
        if(e.id == list[i].workId){
          setList = list[i].sectionVertex
        }
      }
      let changeObj = changeUnRoadPointer(
        this.canvasW,
        this.canvasH,
        {
          roadVertex: this.roadOutList,
          sectionVertex: setList
        }
      );
      let getChangeObj = changeObj[0]
      let canvasArr = this.canvas.getObjects()
      for(let i=0;i<canvasArr.length;i++){
        if(canvasArr[i].id == 'roadChange'){
          this.canvas.remove(canvasArr[i])
        }
      }
      this.setUnRoadOne(this.canvas,getChangeObj)

    },
    setCanvasF(e) {
      let that = this;
      // console.log(e);
      if (e == 1) {
        this.midCanvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
        this.canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
      } else if (e == 2) {
        let zoom = 0.1 + this.canvas.getZoom();
        zoom = Math.max(0.5, zoom); //最小为原来的1/10
        zoom = Math.min(20, zoom); //最大是原来的3倍
        that.$store.commit("setZoom", zoom);
        let zoomPoint = new fabric.Point(event.pageX / 2, event.pageY / 2);
        this.canvas.zoomToPoint(zoomPoint, zoom);
        if (this.midCanvas != "") {
          this.midCanvas.zoomToPoint(zoomPoint, zoom);
        }
      } else if (e == 3) {
        let zoom = -0.1 + this.canvas.getZoom();
        zoom = Math.max(0.5, zoom); //最小为原来的1/10
        zoom = Math.min(20, zoom); //最大是原来的3倍
        that.$store.commit("setZoom", zoom);
        let zoomPoint = new fabric.Point(event.pageX / 2, event.pageY / 2);
        this.canvas.zoomToPoint(zoomPoint, zoom);
        if (this.midCanvas != "") {
          this.midCanvas.zoomToPoint(zoomPoint, zoom);
        }
      } else if (e == 4) {
        if (this.leftOut == true) {
          this.leftOut = false;
          this.leftOutText = "清屏";
          this.$refs.colorContent.style.right = 15 + "px";
        } else {
          this.leftOut = true;
          this.leftOutText = "复屏";
          this.$refs.colorContent.style.right = -400 + "px";
        }
      } else if (e == 5) {
        let list = JSON.parse(localStorage.getItem('carList'))
        list = list.filter((item)=> item!== null)
        let carObj = JSON.parse(localStorage.getItem('carPointObj'))
        let equipCodeGet = list[this.carChangeCode]
        if(equipCodeGet){
          let left = this.canvasW/2 - carObj[equipCodeGet].left
          let top = this.canvasH/2 - carObj[equipCodeGet].top
          console.log(equipCodeGet,left,top)
          var delta = new fabric.Point(left, top);
          this.midCanvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
          this.canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
          this.canvas.relativePan(delta);
          this.midCanvas.relativePan(delta);
        }
        this.carChangeCode = this.carChangeCode>=(list.length-1)?0:(this.carChangeCode+1)
      }
    },
    setTime(data) {
      console.log(data);
      this.value2 = [data.startTime, data.endTime];
      this.startTime = new Date(data.startTime).getTime();
      this.endTime = new Date(data.endTime).getTime();
    },
    onPercentChange(per) {
      console.log(per);
      this.perCode = per;
    },
    playCodeChange(e) {
      console.log(e);
      // let that = this;
      // this.playCode = e;
      // let tokenValue = Cookies.get("token");
      // let setStr =
      //   "/GetWorkTrack?token=" +
      //   tokenValue +
      //   "&workId=" +
      //   this.oldWorkId +
      //   "&playLevel=" +
      //   this.playCode;
      // sendWSPush(setStr, function (res) {
      //   that.drawByWork(that.canvas, that.midCanvas, res);
      // });
    },
    setPlayState() {
      // let that = this;
      // let tokenValue = Cookies.get("token");
      // if (this.playStateText == "暂停") {
      //   this.playStateText = "播放";
      //   let setStr =
      //     "/GetWorkTrack?token=" +
      //     tokenValue +
      //     "&workId=" +
      //     this.oldWorkId +
      //     "&playLevel=" +
      //     this.playCode +
      //     "&playState=" +
      //     0;
      //   // this.carList = []
      //   sendWSPush(setStr, function (res) {
      //     that.drawByWork(that.canvas, that.midCanvas, res);
      //   });
      // } else {
      //   this.playStateText = "暂停";
      //   let setStr =
      //     "/GetWorkTrack?token=" +
      //     tokenValue +
      //     "&workId=" +
      //     this.oldWorkId +
      //     "&playLevel=" +
      //     this.playCode +
      //     "&playState=" +
      //     1;
      //   // this.carList = []
      //   sendWSPush(setStr, function (res) {
      //     that.drawByWork(that.canvas, that.midCanvas, res);
      //   });
      // }
    },
    upSetChange() {
      console.log("up", this.perCode);
      // let that = this;
      // let playTime =
      //   ((this.endTime * 1 - this.startTime * 1) * this.perCode) / 100 +
      //   this.startTime;
      // let tokenValue = Cookies.get("token");
      // let setStr =
      //   "/GetWorkTrack?token=" +
      //   tokenValue +
      //   "&workId=" +
      //   this.oldWorkId +
      //   "&startTime=" +
      //   this.startTime +
      //   "&endTime=" +
      //   this.endTime +
      //   "&playTime=" +
      //   playTime +
      //   "&playLevel=" +
      //   this.playCode;
      // this.carList = [];
      // sendWSPush(setStr, function (res) {
      //   that.drawByWork(that.canvas, that.midCanvas, res);
      // });

      // this.deleteByREChange();
    },
    getSTime: function (e) {
      this.startTime = new Date(
        dateFormat(e[0], "YYYY-MM-DD hh:mm:ss")
      ).getTime();
      this.endTime = new Date(
        dateFormat(e[1], "YYYY-MM-DD hh:mm:ss")
      ).getTime();
      this.allTime = this.endTime - this.startTime;
    },
    startRE: function () {
      console.log("RE");
      // let that = this;
      // this.playCode = 1;
      // let tokenValue = Cookies.get("token");
      // let setStr =
      //   "/GetWorkTrack?token=" +
      //   tokenValue +
      //   "&workId=" +
      //   this.oldWorkId +
      //   "&startTime=" +
      //   this.startTime +
      //   "&endTime=" +
      //   this.endTime +
      //   "&playTime=" +
      //   this.startTime +
      //   "&playLevel=1" +
      //   "&playCode=" +
      //   this.playCode +
      //   "&playState=1";
      // this.carList = [];
      // this.percentNum = 1;
      // sendWSPush(setStr, function (res) {
      //   that.drawByWork(that.canvas, that.midCanvas, res, "clear");
      // });
      // this.deleteByREChange();
    },
    //切换作业
    workChangeAfter: function(oldD){
      console.log(oldD)
      // let that = this
      // let tokenValue = Cookies.get("token");
      // this.carList = [];
      // this.percentNum = 1;
      // this.playCode = 1;
      // let setStr =
      //     "/GetWorkTrack?token=" +
      //     tokenValue +
      //     "&workId=" +
      //     oldD +
      //     "&playLevel=" +
      //     this.playCode +
      //     "&playState=" +
      //     0;
      //   // this.carList = []
      //   setTimeout(()=>{
      //     sendWSPush(setStr, function (res) {
      //       that.drawByWork(that.canvas, that.midCanvas, res);
      //     });
      //   },2000)
        
      // this.deleteByREChange();
    },
    deleteByREChange: function () {
      let that = this;
      let canvasArr = this.canvas.getObjects();
      for (let i = 0; i < canvasArr.length; i++) {
        if (canvasArr[i].id == "group") {
          this.canvas.remove(canvasArr[i]);
        }
        if ((canvasArr[i].id + "").indexOf("groupCarInfo") >= 0) {
          this.canvas.remove(canvasArr[i]);
        }
      }
      let midCanvasArr = this.midCanvas.getObjects();
      for (let i = 0; i < midCanvasArr.length; i++) {
        if (midCanvasArr[i].id == "carPath") {
          that.midCanvas.remove(midCanvasArr[i]);
        }
      }
    },
    warnShow: function () {
      if (this.warnShowCode == 0) {
        this.$refs.warnNumContent.style.right = 360 + "px";
        this.$refs.warnContent.style.right = 0 + "px";
        this.warnShowCode = 1;
      } else {
        this.$refs.warnNumContent.style.right = 0 + "px";
        this.$refs.warnContent.style.right = -360 + "px";
        this.warnShowCode = 0;
      }
    },
    contorFun: function (e, n) {
      //console.log(e)
      this.maskBackCode = e;
      this.maskBackTitle = n;
      this.showCode = true;
      this.hideCode = false;
    },
    maskBack: function () {
      this.showCode = false;
      this.hideCode = true;
    },
    parameterChange: function (e) {
      this.parameterArr = e;
      this.carList = [];
      this.canvas.clear();
      // this.gotosome()
    },
    dimensionChange: function (e) {
      this.midCanvas.clear();
      this.dimension = e;
    },
    getSetInfo: function () {
      getEnginList({pageSize:100}).then((res) => {
        this.canvas = new fabric.Canvas("dhCanvas", {
          perPixelTargetFind: true,
        });
        this.midCanvas = new fabric.Canvas("midCanvas", {
          // perPixelTargetFind: true
        });
        this.projectList = res.data.content.info.list;
        for (let i = 0; i < this.projectList.length; i++) {
          if (this.projectList[i].active == 1) {
            this.search.project = this.projectList[i].id;
          }
        }
        this.getProjectSettingF({projectId:this.search.project})
        let params = { projectId: this.search.project, pageSize: 1000 };
        this.getSection(params);
      });
    },
    getTimeCheckList: function (e) {
      let params = {
        workId: e,
      };
      getWorkTimeList(params).then((res) => {
        console.log(res);
        this.timeList = res.data.content.dataList;
      });
    },
    projectChange: function (e) {
      this.setCanvasF(1)
      this.canvas.clear();
      this.carList=[]
      closeWs();
      this.search.project = e;
      this.changShow = true
      let params = { projectId: e, pageSize: 100 };
      this.getProjectSettingF({projectId:e})
      this.getSection(params);
    },
    workChange: function (e) {
      this.canvas.clear();
      this.carList=[]
      closeWs();
      let params = {
        id: e,
      };
      //console.log(params)
      this.getWorkInfoFun(params);
      let params1 = {
        workId: e,
      };
      this.getTimeCheckList(e)
      // this.workChangeAfter(this.oldWorkId,e)
      this.oldWorkId = e
      if(e == 10000){
        getProjectEquipsList({projectId:this.search.project}).then(res=>{
          this.equipmnetList = res.data.content.dataList;
          this.progress = [];
          this.progress.push({
            name: "总体",
            percentage: 0,
            workTime: "00:00:00",
            remainTime: "00:00:00",
          });
          this.equipmnetList.map((item) => {
            this.progress.push({
              name: item.name,
              percentage: 0,
              workTime: "00:00:00",
              remainTime: "00:00:00",
              code: item.code,
            });
          });
        })
        this.changShow = false
        this.dimension = 1
      }else{
        getWorkEquipsList(params1).then((res) => {
          console.log(res,this.progress,'this.progress')
          this.equipmnetList = res.data.content.dataList;
          let list = res.data.content.dataList;
          this.progress = [];
          this.progress.push({
            name: "总体",
            percentage: 0,
            workTime: "00:00:00",
            remainTime: "00:00:00",
          });
          this.equipmnetList.map((item) => {
            this.progress.push({
              name: item.name,
              percentage: 0,
              workTime: "00:00:00",
              remainTime: "00:00:00",
              code: item.code,
            });
          });
          for(let i=0;i<list.length;i++){
              this.workEquipList[list[i].code] = list[i].name
          }
        });
        this.changShow = true
      }
      
    },
    getSection: function (params) {
      let that = this
      getWorks(params).then((res) => {
        this.workList = res.data.content.info.list;
        this.workList.map(item=>{
            item.id=item.id*1
          })
        if (this.workList.length == 0) {
          this.$message({
            message: "已选工程下暂无作业！请在工程管理新增作业。",
            type: "warning",
          });
          this.search.work = "";
        } else {
          // this.setCode = this.setCode/2
          this.search.work = this.workList[0].id*1;
          // that.workChangeAfter(that.oldWorkId,this.workList[0].id*1)
          that.oldWorkId = this.workList[0].id*1
          that.getWorkInfoFun({ id: this.search.work });
          let set = {
            workId: this.workList[0].id*1,
          };
          this.getTimeCheckList(this.workList[0].id)
          if(this.workList[0].workType == 2 || this.workList[0].workType == 1){
            this.workList.unshift({
              id: 10000,
              name: '全部'
            })
          }
          
          getWorkEquipsList(set).then((res) => {
            this.equipmnetList = res.data.content.dataList;
            let list = res.data.content.dataList;
            this.progress = [];
            this.progress.push({
              name: "总体",
              percentage: 0,
              workTime: "00:00:00",
              remainTime: "00:00:00",
            });
            this.equipmnetList.map((item) => {
              this.progress.push({
                name: item.name,
                percentage: 0,
                workTime: "00:00:00",
                remainTime: "00:00:00",
                code: item.code,
              });
            });
            let setMap = new Map();
            let getData = res.data.content.dataList;
            for (let i = 0; i < getData.length; i++) {
              setMap.set(getData[i].code, getData[i].wheelBackWidth);
            }
            console.log(setMap);

            this.carWidthMap = setMap;
            for(let i=0;i<list.length;i++){
              this.workEquipList[list[i].code] = list[i].name
            }
            // this.scaleCode = localStorage.getItem('scaleCode')
          });
        }
      });
    },
    getWorkInfoFun: function (params) {
      let that = this
      this.canvas.clear();
      this.carList=[]
      // 非标选择全部
      if(params.id == 10000){
        getProjectRoadData({projectId:this.search.project}).then(res=>{
          console.log(res)
          this.canvas.clear()
          this.midCanvas.clear()
          let changeObj = {}
          let list = res.data.content.dataMap.sectionDataList
          this.roadAllList = list
          this.roadOutList = res.data.content.dataMap.roadData.roadVertex
          for(let i=0;i<list.length;i++){
            changeObj = changeUnRoadPointer(
              this.canvasW,
              this.canvasH,
              {
                roadVertex: this.roadOutList,
                sectionVertex: list[i].sectionVertex
              }
            );
            let getChangeObj = changeObj[0];
            this.scaleCode = changeObj[1];
            this.canvas.selectable = false;
            this.initCanvas(this.canvas, this.midCanvas, getChangeObj,1);
            this.carList = []

          }
          
        })
        that.workType = 2
        that.carList = []
        that.canvas.clear()
        let setStr = "/GetWorkStatus?projectId=" + this.search.project
        setTimeout(()=>{
          sendWSPush(setStr,function(res){
            if(res.topic != 'RTCM'){
              that.drawByWork(that.canvas, that.midCanvas, res);
            }
            // that.drawByWork(that.canvas,that.midCanvas,res)
            if(!res.content){
              that.equipmnetList.map(item=>{
                if(item.code==res.equipCode){
                  if(res.online==1 &&res.working==1){
                    item.status=2
                  }else if(res.online==1 &&res.working==0){
                    item.status=0
                  }else if(res.online==0 &&res.working==0){
                    item.status=1
                  }
                }
              })
              let totalProgress = 0;
              let totalworkTime = "00:00:00";
              let totalremainTime = "00:00:00";
              console.log(that.progress, "baocuo1");
              for (let i = 1; i < that.progress.length; i++) {
                if (that.progress[i].code == res.equipCode) {
                  that.progress[i].percentage =
                    (res.progress * 100).toFixed(0) * 1;
                  that.progress[i].workTime = res.workTime; 
                  that.progress[i].remainTime = res.remainTime;
                }
                totalProgress += that.progress[i].percentage;
                if (that.progress[i].workTime > totalworkTime) {
                  totalworkTime = that.progress[i].workTime;
                }
                if (that.progress[i].remainTime > totalremainTime) {
                  totalremainTime = that.progress[i].remainTime;
                }
              }
              that.progress[0].percentage =
                (totalProgress / (that.progress.length - 1)).toFixed(0) * 1;
              that.progress[0].workTime = totalworkTime;
              that.progress[0].remainTime = totalremainTime;
              that.progressList = that.progress
            }
          })
        },500)
        return
      }
      getWorkInfo(params).then((res) => {
        let sectionId = res.data.content.info.sectionId;
        this.workType = res.data.content.info.workType;
        console.log(this.progress)
        if(this.workType == 4 || this.workType == 3){
          this.progressList = [
            {
              name: "总体",
              percentage: 0,
              workTime: "--",
              remainTime: "--",
            },
            {
              name: "摊铺",
              percentage: 0,
              workTime: "--",
              remainTime: "--",
            },
            {
              name: "初压",
              percentage: 0,
              workTime: "--",
              remainTime: "--",
            },
            {
              name: "复压",
              percentage: 0,
              workTime: "--",
              remainTime: "--",
            },
            {
              name: "终压",
              percentage: 0,
              workTime: "--",
              remainTime: "--",
            },
          ]
        }else{
          this.progressList =  [
              {
                name: "总体",
                percentage: 0,
                workTime: "--",
                remainTime: "--",
              }]
        }
        let tokenValue = Cookies.get("token");
        let setStr = "";
        if (this.type == "RE") {
          console.log("RE");
        } else {
          that.canvas.clear();
          that.carList=[]
          setStr =
            "/GetWorkStatus?token=" + tokenValue + "&workId=" + params.id;
          sendWSPush(setStr, function (res) {
            // console.log(res,'1037')
            if(!res.content){
              that.equipmnetList.map(item=>{
                if(item.code==res.equipCode){
                  if(res.online==1 &&res.working==1){
                    item.status=2
                  }else if(res.online==1 &&res.working==0){
                    item.status=0
                  }else if(res.online==0 &&res.working==0){
                    item.status=1
                  }
                }
              })
            }
            if (!res.content && (that.workType == 1 || that.workType == 2)) {
              // console.log("baocuo");
              let totalProgress = 0;
              let totalworkTime = "00:00:00";
              let totalremainTime = "00:00:00";
              console.log(that.progress, "baocuo1");
              for (let i = 1; i < that.progress.length; i++) {
                if (that.progress[i].code == res.equipCode) {
                  that.progress[i].percentage =
                    (res.progress * 100).toFixed(0) * 1;
                  that.progress[i].workTime = res.workTime; 
                  that.progress[i].remainTime = res.remainTime;
                }
                totalProgress += that.progress[i].percentage;
                if (that.progress[i].workTime > totalworkTime) {
                  totalworkTime = that.progress[i].workTime;
                }
                if (that.progress[i].remainTime > totalremainTime) {
                  totalremainTime = that.progress[i].remainTime;
                }
              }
              that.progress[0].percentage =
                (totalProgress / (that.progress.length - 1)).toFixed(0) * 1;
              that.progress[0].workTime = totalworkTime;
              that.progress[0].remainTime = totalremainTime;
              that.progressList = that.progress
            }
            if(res.topic=='total_work_progress' && (that.workType == 3||that.workType == 4) ){
            that.progressList=[
                {
                name: '总体',
                percentage: (res.workProgress.totalProgress*100).toFixed(0)*1,
                workTime: res.workProgress.totalCostTime,
                remainTime: res.workProgress.totalRemainingTime,
                },{
                  name: '摊铺',
                  percentage: (res.workProgress.pavedProgress*100).toFixed(0)*1,
                  workTime: res.workProgress.pavedCostTime,
                  remainTime: res.workProgress.pavedRemainingTime,
                },{
                  name: '初压',
                  percentage: (res.workProgress.initialStageProgress*100).toFixed(0)*1,
                  workTime: res.workProgress.initialStageCostTime,
                  remainTime: res.workProgress.initialStageRemainingTime,
                },{
                  name: '复压',
                  percentage: (res.workProgress.secondStageProgress*100).toFixed(0)*1,
                  workTime: res.workProgress.secondStageCostTime,
                  remainTime: res.workProgress.secondStageRemainingTime,
                },{
                  name: '终压',
                  percentage: (res.workProgress.thirdStageProgress*100).toFixed(0)*1,
                  workTime: res.workProgress.thirdStageCostTime,
                  remainTime: res.workProgress.thirdStageRemainingTime,
                }]
              }
            if(res.topic != 'RTCM'){
              that.drawByWork(that.canvas, that.midCanvas, res);
            }
            
          });
        }
        console.log('123123')
        getRoadSectionPointer({workId: params.id, sectionId: sectionId }).then((res) => {
          //console.log(res)
          console.log('123123')
          if (res.data.content.dataMap == {}) {
            this.$message({
              message: "未绑定道路数据!",
              type: "success",
            });
          } else {
            this.setCode = this.setCode + 1
            this.roadType = res.data.content.dataMap.roadType;
            if (res.data.content.dataMap.roadType == 0) {
              let changeObj = changeRoadPointer(
                this.canvasW,
                this.canvasH,
                res.data.content.dataMap,
                false
              );
              let getChangeObj = changeObj[0];
              this.scaleCode = changeObj[1];
              console.log(this.scaleCode)
              this.$store.commit("setScaleCode", this.scaleCode);

              // var canvas = new fabric.Canvas("dhCanvas",{
              //     perPixelTargetFind: true
              // });
              this.canvas.selectable = false;
              // //console.log(this.canvas.getObjects())
              // let el = this.canvas.getObjects()
              // this.canvas.remove(el)
              this.midCanvas.clear();
                this.canvas.clear();
              // canvas.zoomToPoint([zoomPoint], 1);
              console.log(getChangeObj)
              this.initCanvas(this.canvas, this.midCanvas, getChangeObj,'',sectionId);
              this.workChangeAfter(params.id)
              // setTimeout(() => {
              //   let tokenValue = Cookies.get("token");
              //   let setStr = "";
              //   if (that.type == "RE") {
              //     console.log("RE");
              //     that.carList = [];
              //   } else {
              //     setStr =
              //       "/GetWorkStatus?token=" +
              //       tokenValue +
              //       "&workId=" +
              //       params.id;
              //     sendWSPush(setStr, function (res) {
              //       if (!res.content) {
              //         // console.log("baocuo");
              //         let totalProgress = 0;
              //         let totalworkTime = "00:00:00";
              //         let totalremainTime = "00:00:00";
              //         // console.log(res, res.progress, that.progress, "baocuo1");
              //         for (let i = 1; i < that.progress.length; i++) {
              //           if (that.progress[i].code == res.equipCode) {
              //             that.progress[i].percentage =
              //               (res.progress * 100).toFixed(0) * 1;
              //             that.progress[i].workTime = res.workTime;
              //             that.progress[i].remainTime = res.remainTime;
              //           }
              //           totalProgress += that.progress[i].percentage;
              //           if (that.progress[i].workTime > totalworkTime) {
              //             totalworkTime = that.progress[i].workTime;
              //           }
              //           if (that.progress[i].remainTime > totalremainTime) {
              //             totalremainTime = that.progress[i].remainTime;
              //           }
              //         }
              //         that.progress[0].percentage =
              //           (totalProgress / (that.progress.length - 1)).toFixed(0) * 1;
              //         that.progress[0].workTime = totalworkTime;
              //         that.progress[0].remainTime = totalremainTime;
              //       }
              //       that.drawByWork(that.canvas, that.midCanvas, res);
              //     });
              //   }
              // }, 1000);
              this.carList = []
            } else {
                let changeObj = changeUnRoadPointer(
                  this.canvasW,
                  this.canvasH,
                  res.data.content.dataMap
                );
                this.getChangeObj = changeObj[0];
                // console.log(changeObj[0], "999999999999999顶点坐标");
                // let changeObj = changeRoadPointer(1920,1015,res.data.content.dataMap)
                // let getChangeObj = changeObj[0]
                // that.roadPathList = changeObj[0];
                this.scaleCode = changeObj[1];
                this.$store.commit("setScaleCode", this.scaleCode);
                this.canvas.selectable = false;
                this.midCanvas.clear();
                this.canvas.clear();
                this.initCanvas(
                  this.canvas,
                  this.midCanvas,
                  this.getChangeObj,
                  1
                );
              //   setTimeout(() => {
              //   let tokenValue = Cookies.get("token");
              //   let setStr = "";
              //   if (that.type == "RE") {
              //     console.log("RE");
              //     that.carList = [];
              //   } else {
              //     setStr =
              //       "/GetWorkStatus?token=" +
              //       tokenValue +
              //       "&workId=" +
              //       params.id;
              //     sendWSPush(setStr, function (res) {
              //       if (!res.content) {
              //         // console.log("baocuo");
              //         let totalProgress = 0;
              //         let totalworkTime = "00:00:00";
              //         let totalremainTime = "00:00:00";
              //         // console.log(res, res.progress, that.progress, "baocuo1");
              //         for (let i = 1; i < that.progress.length; i++) {
              //           if (that.progress[i].code == res.equipCode) {
              //             that.progress[i].percentage =
              //               (res.progress * 100).toFixed(0) * 1;
              //             that.progress[i].workTime = res.workTime;
              //             that.progress[i].remainTime = res.remainTime;
              //           }
              //           totalProgress += that.progress[i].percentage;
              //           if (that.progress[i].workTime > totalworkTime) {
              //             totalworkTime = that.progress[i].workTime;
              //           }
              //           if (that.progress[i].remainTime > totalremainTime) {
              //             totalremainTime = that.progress[i].remainTime;
              //           }
              //         }
              //         that.progress[0].percentage =
              //           (totalProgress / (that.progress.length - 1)).toFixed(0) * 1;
              //         that.progress[0].workTime = totalworkTime;
              //         that.progress[0].remainTime = totalremainTime;
              //       }
              //       that.drawByWork(that.canvas, that.midCanvas, res);
              //     });
              //   }
              // }, 1000);
            }
          }
        });
      });
    },

    tabChange: function (e) {
      this.tabChangeCode = e;
      if (e == 2) {
        this.showCode = false;
        this.hideCode = false;
      }
    },
  },
  components: {
    WorkSet,
    CProgress,
    RollLegend
  },
  sockets: {
    connection() {
      //console.log(data)
    },
    news() {
      //console.log(data)
    },
  },
  destroyed() {
    // this.websock.close()
    closeWs();
    clearInterval(this.interFun)
  },
  beforeDestroy() {
    this.$emit("changeArrowShow", true); // 隐藏arrow
  },
};
</script>

<style lang="scss">
.progressContent {
  .el-input {
    height: 35px;
    width: 70px;
    input {
      height: 35px !important;
      width: 70px !important;
      border-radius: 0;
    }
  }
}
.setMonitorItem {
  width: 100%;
  .projectCon {
    height: 35px;
    width: 184px;
    margin-left: 11px;
    float: left;
    line-height: 35px;
    font-size: 14px;
    color: #282828;
    .el-input {
      height: 35px;
      width: 184px;
      input {
        height: 35px !important;
        width: 184px !important;
        border-radius: 0;
      }
    }
    .mileage {
      height: 35px;
      width: 75px;

      input {
        height: 35px !important;
        width: 75px !important;
      }
    }
    .mileage_1 {
      margin: 0 9px;
    }
    .mileage_2 {
      margin-left: 10px;
    }
    .el-date-editor {
      // height: ;
    }
  }
  .projectConD {
    height: 35px;
    width: 303px;
    margin-left: 11px;
    float: left;
    line-height: 35px;
    font-size: 14px;
    color: #282828;
    .el-date-editor {
      height: 35px;
      width: 303px;
    }
    .el-range-separator {
      font-size: 12px;
      width: 22px;
      line-height: 28px;
      padding: 0 2px;
    }
    .el-range-input {
      width: 130px;
    }
    .el-input__icon {
      height: 31px;
      display: none;
    }
  }
  .workCon {
    height: 35px;
    width: 108px;
    margin-left: 11px;
    float: left;
    line-height: 35px;
    font-size: 14px;
    color: #282828;
    .el-input {
      height: 35px;
      width: 108px;
      input {
        height: 35px !important;
        width: 108px !important;
        border-radius: 0;
      }
    }
  }
  .setMonitorItem{
    .el-input{
      .el-input__inner{
        font-size: 12px !important;
      }
    }
    
  }
}
@keyframes leftToShow {
  from {
    left: -400px;
  }
  to {
    left: 0px;
  }
}
@keyframes leftToHide {
  from {
    left: 0px;
  }
  to {
    left: -400px;
  }
}
.infoListShow {
  width: 370px;
  margin: 0 auto;
  margin-top: 14px;
  // position: relative;
  .infoItemSetMask {
    height: 577px;
    width: 400px;
    position: absolute;
    bottom: 0;
    left: -400px;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 100;
    .setMaskTitle {
      height: 30px;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      line-height: 30px;
      font-size: 14px;
      text-align: left;
      padding-left: 20px;
      background-color: #e96b5a;
      color: #ffffff;
    }
    .workSet {
      height: 547px;
      width: 100%;
      position: absolute;
      top: 30px;
      left: 0;
      background-color: rgba(255, 255, 255, 1);
    }
    .setMaskContent {
      height: 547px;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
    .maskBack {
      height: 30px;
      width: 30px;
      line-height: 30px;
      position: absolute;
      top: 0;
      right: 0;
      color: #ffffff;
      font-size: 16px;
      z-index: 10;
      text-align: center;
      cursor: pointer;
    }
  }
  .leftToShowClass {
    animation: leftToShow 0.5s infinite;
    animation-fill-mode: forwards;
    animation-iteration-count: 1;
  }
  .leftToHideClass {
    animation: leftToHide 1s infinite;
    animation-fill-mode: forwards;
    animation-iteration-count: 1;
  }
  .contorl_1 {
    display: inline-block;
    font-size: 12px;
    line-height: 13px;
    padding: 7px 8px;
    color: #ffffff;
    background-color: #e96b5a;
    border-radius: 2px;
  }
  .contorl_2 {
    display: inline-block;
    font-size: 12px;
    line-height: 13px;
    padding: 7px 8px;
    color: #e24747;
    background: rgba(252, 232, 232, 1);
    border: 1px solid rgba(251, 158, 158, 1);
    border-radius: 2px;
    margin-left: 6px;
  }
  .el-table__header-wrapper {
    height: 30px;
    border: 1px solid rgba(228, 231, 237, 1);
    .el-table__header {
      height: 30px !important;
      tr {
        th {
          background-color: #f5f5f5 !important;
          color: #888888 !important;
          font-size: 12px !important;
          padding: 0 !important;
          height: 30px !important;
          font-weight: 100 !important;
        }
      }
    }
  }
  .el-table__body-wrapper {
    height: 530px;
    overflow-y: auto !important;
    overflow-x: hidden;
    tr {
      td {
        padding: 20px 0 !important;
        color: #555555 !important;
        font-size: 14px !important;
      }
    }
  }
}
.workProgress_content {
  .el-progress__text {
    color: #222222 !important;
  }
}
.canvas-container {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
}
</style>

<style lang="scss" scoped="">
.contorlContent {
  height: 40px;
  width: 500px;
  background-color: #ffffff;
  position: fixed;
  top: 62px;
  right: 18px;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  opacity: 1;
  z-index: 999;
  display: flex;
  cursor: pointer;
  .itemContorl {
    flex: 1;
    position: relative;
    .line {
      width: 1px;
      height: 15px;
      background: #eaeaea;
      position: absolute;
      top: 12px;
      right: 0;
    }
    .type {
      height: 18px;
      width: 18px;
      position: absolute;
      top: 11px;
      left: 19px;
    }
    .type_1 {
      background-image: url("../../images/icon/type_1.png");
      background-size: 100% 100%;
    }
    .type_2 {
      background-image: url("../../images/icon/type_2.png");
      background-size: 100% 100%;
    }
    .type_3 {
      background-image: url("../../images/icon/type_3.png");
      background-size: 100% 100%;
    }
    .type_4 {
      background-image: url("../../images/icon/type_4.png");
      background-size: 100% 100%;
    }
    .type_5 {
      background-image: url("../../images/icon/icon_5.png");
      background-size: 100% 100%;
    }
    .text {
      height: 12px;
      line-height: 12px;
      display: inline-block;
      position: absolute;
      top: 14px;
      color: #555555;
      left: 47px;
      font-size: 12px;
    }
  }
}
.progressContent {
  height: 90px;
  width: 100%;
  position: fixed;
  background: #ffffff;
  left: 0;
  bottom: 0;
  padding: 24px;
  .playAndPuase_1 {
    height: 20px;
    width: 20px;
    background-image: url("../../images/icon/play.png");
    background-size: 100% 100%;
    position: absolute;
    top: 50px;
    left: 24px;
    cursor: pointer;
  }
  .playAndPuase_2 {
    height: 20px;
    width: 20px;
    background-image: url("../../images/icon/puase.png");
    background-size: 100% 100%;
    position: absolute;
    top: 50px;
    left: 24px;
    cursor: pointer;
  }
  .nowDateTimeShow {
    height: 20px;
    line-height: 20px;
    position: absolute;
    color: #777777;
    font-size: 14px;
    top: 50px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  .playState {
    height: 20px;
    line-height: 20px;
    position: absolute;
    top: 50px;
    color: #777777;
    font-size: 14px;
    left: 24px;
    cursor: pointer;
  }
  .speedText {
    height: 20px;
    line-height: 20px;
    position: absolute;
    top: 50px;
    color: #777777;
    font-size: 14px;
    left: 60px;
    cursor: pointer;
  }
  .playCodeChange {
    position: absolute;
    top: 43px;
    left: 130px;
  }
}
.content {
  height: 1015px;
  width: 1920px;
  position: relative;
  .setCarInfo {
    height: 70px;
    width: 150px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    background-color: #e1e1e1;
    border: 1px #e1e1e1 solid;
    border-radius: 5px;
    .setCarTitle {
      height: 30px;
      width: 100%;
      position: absolute;
      line-height: 30px;
      font-size: 12px;
      text-align: center;
      color: #282828;
      top: 0;
      left: 0;
    }
    .setCarBtnL {
      height: 30px;
      width: 60px;
      line-height: 30px;
      font-size: 12px;
      position: absolute;
      bottom: 5px;
      left: 10px;
      color: #ffffff;
      background-color: rgba(233, 107, 90, 1);
      border-radius: 3px;
      text-align: center;
      cursor: pointer;
    }
    .setCarBtnR {
      height: 30px;
      width: 60px;
      line-height: 30px;
      font-size: 12px;
      position: absolute;
      bottom: 5px;
      right: 10px;
      color: #282828;
      background-color: rgba(233, 107, 90, 0.3);
      border-radius: 3px;
      text-align: center;
      cursor: pointer;
    }
  }
  .toPlay {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: aqua;
    color: black;
    font-size: 20px;
    width: 60px;
    position: absolute;
    top: 50px;
    right: 50px;
    cursor: pointer;
  }

  #myCanvas {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
  }
  #midCanvas {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
  }
  #dhCanvas {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
  }
  .warnContent {
    min-height: 300px;
    max-height: 500px;

    overflow: hidden;
    overflow-y: scroll;
    width: 360px;
    position: fixed;
    right: -360px;
    top: 30%;
    background-color: #ffffff;
    z-index: 100;
    .itemTop {
      height: 28px;
      width: 100%;
      margin-top: 8px;
      .itemType {
        height: 28px;
        line-height: 26px;
        padding: 0 8px;
        background: #fce8e8;
        border: 1px solid #fb9e9e;
        border-radius: 2px;
        float: left;
        margin-left: 16px;
        color: #e24747;
        font-size: 12px;
      }
      .itemEquipName {
        height: 28px;
        line-height: 28px;
        color: #282828;
        font-size: 14px;
        float: left;
        margin-left: 8px;
        font-weight: bold;
      }
      .setStop {
        height: 28px;
        line-height: 26px;
        padding: 0 8px;
        background: #fce8e8;
        border: 1px solid #fb9e9e;
        border-radius: 2px;
        float: right;
        margin-right: 10px;
        color: #e24747;
        font-size: 12px;
        cursor: pointer;
      }
    }
    .itemTitle {
      height: 30px;
      width: 100%;
      position: relative;
      .bgLine {
        display: inline-block;
        height: 14px;
        width: 4px;
        position: absolute;
        left: 21px;
        top: 15px;
        background: #e96b5a;
      }
      .itemTitleText {
        display: inline-block;
        height: 15px;
        line-height: 15px;
        position: absolute;
        top: 15px;
        left: 30px;
        color: #282828;
        font-size: 14px;
        font-weight: bold;
      }
    }
    .itemContent {
      width: 100%;
      height: auto;
      display: flex;
      flex-wrap: wrap;

      .itemShow {
        // width: 50%;
        height: 28px;
        line-height: 14px;
        font-size: 14px;
        padding: 7px 20px 7px 26px;
        color: #e24747;
        position: relative;
        margin-top: 12px;
        margin-left: 11px;
        background: #ffe8e8;
        .redPointer {
          display: inline-block;
          height: 8px;
          width: 8px;
          border-radius: 50%;
          background-color: red;
          position: absolute;
          top: 10px;
          left: 10px;
        }
      }
    }
  }
  .warnNumContent {
    height: 90px;
    width: 36px;
    background: #e96b5a;
    position: fixed;
    top: 32%;
    right: 0;
    cursor: pointer;
    .warnNum {
      width: 20px;
      height: 20px;
      background: #ffffff;
      position: absolute;
      border-radius: 50%;
      top: 12px;
      left: 50%;
      transform: translateX(-50%);
      line-height: 20px;
      text-align: center;
      color: #e24747;
      font-size: 16px;
    }
    .warnText {
      width: 15px;
      height: auto;
      position: absolute;
      top: 42px;
      left: 50%;
      transform: translateX(-50%);
      color: #ffffff;
      font-size: 14px;
      word-wrap: normal;
    }
  }
  .leftOut {
    left: -500px !important;
  }
  .setMonitor {
    height: auto;
    width: 400px;
    position: fixed;
    background-color: #ffffff;
    top: 126px;
    left: 15px;
    padding-top: 16px;
    padding-bottom: 16px;
    .title_1 {
      height: 16px;
      width: 100%;
      position: relative;
      margin-bottom: 17px;
      .iconShow {
        width: 4px;
        height: 16px;
        background: rgba(233, 107, 90, 1);
        position: absolute;
        top: 0;
        left: 16px;
      }
      .titleText {
        height: 14px;
        line-height: 14px;
        font-size: 14px;
        font-weight: bold;
        color: #222222;
        position: absolute;
        top: 0;
        left: 28px;
      }
    }
    .timeCheckItem {
      width: 100%;
      height: auto;
      margin-top: 13px;
      padding-left: 14px;
      .timeCheck {
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #777777;
        cursor: pointer;
      }
    }

    .setMonitorItem {
      width: 100%;
      height: 35px;
      margin-top: 13px;
      position: relative;
      // background-color: aqua;

      .itemText {
        height: 35px;
        line-height: 35px;
        width: auto;
        padding-left: 14px;
        color: #777777;
        font-size: 14px;
        float: left;
      }
      .nowDateTimeShow {
        height: 20px;
        line-height: 20px;
        position: absolute;
        color: #777777;
        font-size: 14px;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  .infoListContent {
    width: 400px;
    height: 622px;
    position: fixed;
    top: 288px;
    left: 15px;
    background-color: #ffffff;
    overflow: hidden;
    .infoTab {
      height: 45px;
      width: 100%;
      display: flex;
      .tabItem {
        flex: 1;
        line-height: 45px;
        text-align: center;
        font-size: 14px;
        color: #555555;
        cursor: pointer;
        background-color: #f5f7fa;
      }
      .tabItem_r,
      .tabItem_w {
        background-color: #ffffff;
        // border-right: 1px solid rgba(228, 231, 237, 1);
        // border-bottom: 1px solid rgba(228, 231, 237, 1);
        color: #e24747 !important;
        font-weight: bold;
      }
      .tabItem_l {
        background-color: #ffffff;
        // border-left: 1px solid rgba(228, 231, 237, 1);
        // border-bottom: 1px solid rgba(228, 231, 237, 1);
        color: #e24747 !important;
        font-weight: bold;
      }
    }
  }
  .contorClick {
    display: inline-block;
    padding: 5px 15px;
    background: rgba(233, 107, 90, 0.35);
    color: rgba(233, 107, 90, 1);
    cursor: pointer;
  }
  .wordStatus_1 {
    display: inline-block;
    padding: 4px 9px;
    background: rgba(242, 242, 245, 1);
    color: #999999;
  }
  .wordStatus_2 {
    display: inline-block;
    padding: 4px 9px;
    background: rgba(225, 235, 250, 1);
    color: #10c766;
  }
  .wordStatus_3 {
    display: inline-block;
    padding: 4px 9px;
    background: rgba(221, 240, 229, 1);
    color: #2273f8;
  }
  .wordStatus_4 {
    display: inline-block;
    padding: 4px 9px;
    background: rgba(221, 240, 229, 1);
    color: #E96C5A;
  }
  .colorContent {
    height: 130px;
    width: 300px;
    position: fixed;
    right: 15px;
    bottom: 110px;
    background-color: #ffffff;
    .rollImg {
      width: 290px;
      height: 90px;
      position: absolute;
      background-image: url("../../images/all/rollNum.png");
      background-size: 100% 100%;
      bottom: 10px;
      left: 0px;
      background-size: 100% 100%;
    }
    .icvImg {
      width: 290px;
      height: 90px;
      position: absolute;
      background-image: url("../../images/all/icvNum.png");
      background-size: 100% 100%;
      bottom: 10px;
      left: 0px;
      background-size: 100% 100%;
    }
    .colorType {
      height: 28px;
      width: 248px;
      position: absolute;
      display: flex;
      left: 50%;
      transform: translateX(-50%);
      top: 13px;
      .colorItem {
        flex: 1;
        line-height: 28px;
        color: #888888;
        font-size: 12px;
        text-align: center;
      }
      .colorItem_1 {
        border-radius: 4px 0px 0px 4px;
        border: 1px solid rgba(228, 231, 237, 1);
      }
      .colorItem_2 {
        // border-radius: 0px 4px 4px 0px;
        border: 1px solid rgba(228, 231, 237, 1);
      }
      .colorItem_3 {
        // border-radius: 0px 4px 4px 0px;
        border: 1px solid rgba(228, 231, 237, 1);
      }
      .colorItem_4 {
        border-radius: 0px 4px 4px 0px;
        border: 1px solid rgba(228, 231, 237, 1);
      }
      .colorActive {
        border: none;
        color: #ffffff !important;
        background-color: #e96b5a;
      }
    }
  }
}
.workProgress {
  width: 90%;
  margin: 0 auto;
  margin-top: 20px;
  color: #222222;
  .workProgress_title {
    font-size: 16px;
    font-weight: bold;
  }
  .workProgress_content {
    height: 55px !important;
    margin-top: 12px;
    margin-left: 18px;
    font-size: 14px;
    line-height: 24px;
    height: 24px;
    border-bottom: 1px solid #e1e1e1;
  }
}
.rollLegend{
  transform: scale(0.8);
  position: relative;
  right: 30px;
  top: 35px;
}
</style>